import { generatePath as routerGeneratePath } from 'react-router-dom';

import { formatOptionalParams } from './formatOptionalParams';

export const generatePath = (
  route: string,
  values: Record<string, string | number | boolean | undefined>
): string => routerGeneratePath(formatOptionalParams(route), values);
